<template>
  <div class="nav-monitor-wrap">
    <BMap @loaded="bmapLoaded" />
    <!-- <el-input
      v-model="coord"
      style="position: absolute;right:10px;top: 10px;z-index: 10;width: 200px;"
      @change="inputChange"
    ></el-input> -->
    <slot></slot>
  </div>
</template>

<script>
import BMap from '@/components/bmapGL';

import bmapTheme from '@/utils/bmapTheme';

import { to, toCoordinate } from '@/utils/bmapUtil';

export default {
  components: { BMap },
  data() {
    return {
      bmap: null,
      coord: ''
    };
  },
  methods: {
    bmapLoaded(bmap) {
      this.bmap = bmap;
      // this.registeBmapClick();
      this.$nextTick(() => {
        const point = new BMapGL.Point(116.387456, 39.925406);

        this.bmap.centerAndZoom(point, 12);

        this.bmap.setMapStyleV2({ styleJson: bmapTheme['dark'] });

        this.$emit('loaded', this);
      });
    },

    inputChange() {
      this.locateTo(this.coord.split(','));
    },

    locateTo({ center, zoom = 15, tilt = 40 }) {
      return to(this.bmap, {
        center: toCoordinate(center),
        zoom,
        tilt
      });
    }
  }
};
</script>

<style lang="scss">
.nav-monitor-wrap {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
